<script setup lang="ts">
import { useLayoutStore } from "@/stores/layout";
useLayoutStore();
</script>
<template>
    <div v-if="isVisible" class="fixed-top">
        <div class="container mt-5">
            <div class="row justify-content-center">
                <div class="col-6">
                    <div class="alert alert-danger" role="alert">
                        <strong class="text-danger">Informações apenas para DESENVOLVIMENTO</strong><br>
                        Width: <strong class="text-danger">{{ innerWidth }}</strong> px / LIMIT = {{ limitWidth }} px<br>
                        Height: <strong class="text-danger">{{ innerHeight }}</strong> px / LIMIT = {{ limitHeight }} px<br>
                        {{ isMobile ? 'Mobile' : 'Desktop' }} detected!<br>
                        <hr>
                        Mude a variável VITE_DEV_SHOW_SCREEN_SIZE_INFO no arquivo .env para esconder este alerta.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { mapStores } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
    name: "DetectScreenSizeComponent",
    data() {
        return {
            isVisible: false,
            innerWidth: 0,
            innerHeight: 0,
            limitWidth: 1170,
            limitHeight: 580,
            isMobile: false
        };
    },
    computed:{
        ...mapStores(useLayoutStore)
    },
    watch:{
        isMobile(){
            this.LayoutStore.setDeviceType(this.isMobile ? 'mobile' : 'desktop');
        }
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        this.isVisible = import.meta.env.VITE_DEV_SHOW_SCREEN_SIZE_INFO === 'true'
    },
    methods: {
        handleResize(): void {
            this.innerWidth = window.innerWidth
            this.innerHeight = window.innerHeight
            this.isMobile = this.onMobileSizeDetected(this.innerWidth, this.innerHeight);
            this.escoderBarraDeRolagemParaMobile(this.isMobile);
            this.$emit('onScreenSizeChanged', this.isMobile);
        },
        onMobileSizeDetected(innerWidth: number, innerHeight: number): boolean {
            if (import.meta.env.VITE_DEV_SHOW_SCREEN_SIZE_INFO === 'true') {
                let info = {
                    width: innerWidth,
                    height: innerHeight,
                    limitWidth: this.limitWidth,
                    limitHeight: this.limitHeight,
                    isMobile: this.isMobile
                }                
                console.table(info);
            }

            return (innerWidth <= this.limitWidth || innerHeight <= this.limitHeight);
        },
        escoderBarraDeRolagemParaMobile(isMobile: boolean): void {
            if (isMobile) {
                document.body.style.overflowX = 'hidden';
            }
            else {
                document.body.style.overflowX = 'auto';
            }
        }
    },
});
</script>
